module.exports = __webpack_public_path__ + "img/4.8337d847.jpg";